module.exports = __webpack_public_path__ + "static/media/gal0707.0f2b4dcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal07/gal0707.jpg
// module id = 516
// module chunks = 0